import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, Button, Grid, Typography, Dialog } from "@mui/material"; // Added Dialog

import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import LoginLogo from "../../assets/images/LoginPageLogo.png";
import LoginBgImage from "../../assets/images/LoginPageBgImg.png";
import ViewImage from "../../assets/images/Show.png";
import Styles from "../../assets/styles/login.module.scss";
import { showToast } from "../../redux/Reducer/toastReducer";
import login from "../../services/login.service";
import { CommonEnums } from "../../constant/commonEnumType";
import { getToken } from "firebase/messaging";
import { getMessagingInstance, VAPID_KEY } from "../../utils/firebase";
import saveToken from "../../services/token.service";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notificationDenied, setNotificationDenied] = useState(false); // New State

  const validationSchema = yup.object().shape({
    email: yup.string().required(CommonEnums.RequiredError),
    password: yup.string().required(CommonEnums.RequiredError),
  });

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const res = await login(values);
      if (res?.data?.data) {
        localStorage.setItem(
          "role",
          res?.data?.data.projectData.filter((e) => e?.name === "Feedback")[0]
            ?.role
        );
        localStorage.setItem(
          "projectId",
          res?.data?.data.projectData.filter((e) => e?.name === "Feedback")[0]
            ?._id
        );
        var item = res.data.data || {};
        localStorage.setItem("name", item?.name);
        localStorage.setItem("token", item?.token);
        localStorage.setItem("email", item?.email);
        localStorage.setItem("userId", item?.userId);
        localStorage.setItem("userName", item?.userName);
        localStorage.setItem("isOverAllAdmin", item?.isOverAllAdmin);
        localStorage.setItem("isAdmin", item?.isAdmin);

        const role = res?.data?.data.projectData.filter((e) => e?.name === "Feedback")[0]?.role;
        console.log("Login Role identified:", role);

        dispatch(showToast({ message: "Login Successfully", type: "success" }));

        if ("Notification" in window) {
          const permission = await Notification.requestPermission();
          console.log("Notification permission status:", permission);

          // Try to get and save token regardless of permission status
          try {
            const messaging = await getMessagingInstance();
            if (messaging) {
              const webToken = await getToken(messaging, { vapidKey: VAPID_KEY });

              if (webToken) {
                const payload = {
                  webToken,
                  email: item?.email
                }
                const res = await saveToken(payload);
                console.log("Token saved successfully:", res);
              }
            } else {
              console.log("Messaging is not supported in this browser.");
            }
          } catch (error) {
            console.log("Could not get FCM token:", error);
          }

          // Navigate or show modal based on permission
          if (permission === "granted") {
            navigate("/dashboard");
          } else if (permission === "denied") {
            setNotificationDenied(true);
          } else {
            // Default case (dismissed or ignored), navigate anyway
            navigate("/dashboard");
          }
        } else {
          navigate("/dashboard");
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      dispatch(showToast({ message: "Invalid credential", type: "error" }));
    }
  };


  return (
    <Box className={Styles.loginContainer}>
      <Box className={Styles.loginBox}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
            alignItems: "center",
          }}
        >
          <img
            src={LoginLogo}
            alt="logo"
            style={{ height: "108px", width: "100px" }}
          />
          <Typography
            sx={{
              fontFamily: "Open Sans, sans-serif",
              fontSize: "24px",
              fontWeight: 600,
              color: "#000000",
            }}
          >
            Welcome to My WSH
          </Typography>
          <Typography
            sx={{
              fontFamily: "Open Sans, sans-serif",
              fontSize: "14px",
              fontWeight: 400,
              color: "#263A43",
              textAlign: "center",
            }}
          >
            Where every login is a step towards realizing <br />
            your project's potential
          </Typography>
        </Box>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => handleLogin(values)}
        >
          {({ touched, errors }) => (
            <Form>
              <Grid container rowGap={2.6} mt={4}>
                <Grid item xs={12}>
                  <div className="wsh-form-control">
                    <Typography className={Styles.loginInputTitle}>
                      User Name
                    </Typography>
                    <Field
                      name="email"
                      className={Styles.loginInput}
                      placeholder="Type your user name here"
                    />
                    <div className="form-error">
                      {touched.email && errors.email && errors.email}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className="wsh-form-control">
                    <Typography className={Styles.loginInputTitle}>
                      Password
                    </Typography>
                    <div className={Styles.passwordContainer}>
                      <Field
                        name="password"
                        className={Styles.loginInput}
                        placeholder="Type your password here"
                        type={showPass ? "text" : "password"}
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          setShowPass(!showPass);
                          e.preventDefault();
                        }}
                        aria-label="Toggle password visibility"
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={ViewImage}
                          alt="Toggle visibility"
                          style={{ display: "inline" }}
                        />
                      </button>
                    </div>
                    <div className="form-error">
                      {touched.password && errors.password && errors.password}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Typography
                      sx={{
                        fontFamily: "Open Sans, sans-serif",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#00675D",
                        cursor: "pointer"
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} mt={1}>
                  <Button
                    name="name"
                    loading={loading}
                    type="submit"
                    className={`${Styles.loginButton} w-100`}
                  >
                    Login
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
      <Box className={Styles.imageBox}>
        <img src={LoginBgImage} alt="bg" />
      </Box>


      <Dialog
        open={notificationDenied}
        onClose={() => {
          setNotificationDenied(false);
          navigate("/dashboard");
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box sx={{ p: 3, maxWidth: 400 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontFamily: 'Open Sans, sans-serif' }}>
            Notifications Blocked
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: '#263A43', fontFamily: 'Open Sans, sans-serif' }}>
            We strongly recommend enabling notifications to stay updated.
          </Typography>
          <Typography variant="body2" sx={{ mb: 3, color: '#263A43', fontFamily: 'Open Sans, sans-serif', fontWeight: 600 }}>
            To enable: Click the lock icon or filter icon in your address bar &gt; Site Settings &gt; Notifications &gt; Allow.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                setNotificationDenied(false);
                navigate("/dashboard");
              }}
              variant="contained"
              sx={{
                backgroundColor: '#00675D',
                color: 'white',
                '&:hover': { backgroundColor: '#00554d' },
                textTransform: 'none'
              }}
            >
              OK, proceed to Dashboard
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box >
  );
};

export default Login;
